/** Stageville is its own product now; its old path here sends people there. */
const STAGEVILLE_URL = 'https://stageville.io'

/** Where somebody is sent does not depend on who they are, so nothing waits. */
export function Play() {
  window.location.replace(STAGEVILLE_URL)
  return null
}
